/**
 * Display name for guest uploads/comments.
 * Returns "Anonymous" when both guestName and guestPhone are null/empty.
 */
export function getGuestDisplayName(guestName, guestPhone) {
  const name = (guestName && String(guestName).trim()) || '';
  const phone = (guestPhone && String(guestPhone).trim()) || '';
  if (name) return name;
  if (phone) return phone;
  return 'Anonymous';
}
